import type { EarlyStageVerificationStatus } from "../api/earlyStageMembershipApi";
import { isEarlyStageMembership, isPaidPortalMember } from "./membershipTier";

type EarlyStageUserFields = {
  hasPaid?: number | null;
  stripeStatus?: string | null;
  membershipName?: string | null;
  earlyStageVerificationStatus?: string | null;
  earlyStagePriceTier?: string | null;
};

/** Unpaid user must stay on `/register-user` (pending, rejected, price plan, or early stage not finished). */
export function shouldResumeEarlyStageRegistration(
  status: EarlyStageVerificationStatus | null,
  user?: EarlyStageUserFields | null,
): boolean {
  if (isPaidPortalMember(user)) return false;

  const fromApi = (status?.status ?? "").trim();
  const fromUser = (user?.earlyStageVerificationStatus ?? "").trim();
  const verificationStatus = fromApi || fromUser;

  if (
    verificationStatus === "Pending" ||
    verificationStatus === "UnderReview"
  ) {
    return true;
  }
  if (verificationStatus === "Rejected") {
    const tier = (status?.priceTier ?? user?.earlyStagePriceTier ?? "").trim();
    return tier === "Premium10";
  }
  // Unpaid approved members must finish registration (verification notice → terms → checkout).
  if (verificationStatus === "Approved") {
    return true;
  }
  if (
    isEarlyStageMembership(user?.membershipName) &&
    (!verificationStatus || verificationStatus === "NotSubmitted")
  ) {
    return true;
  }
  return false;
}
